import React, { useState, useEffect } from "react";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";

import "./YearPicker.scss";

interface YearPickerProps {
  initialYear?: number | null;
  onYearChange?: (year: number) => void;
}

export const YearPicker: React.FC<YearPickerProps> = ({
  onYearChange,
  initialYear = null,
}) => {
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState<number>(initialYear || currentYear);

  useEffect(() => {
    if (onYearChange) {
      onYearChange(year);
    }
  }, [year, onYearChange]);

  const handlePreviousYear = (): void => {
    setYear((prevYear) => {
      return prevYear - 1;
    });
  };

  const handleNextYear = (): void => {
    if (year < currentYear) {
      setYear((prevYear) => prevYear + 1);
    }
  };

  const isNextYearDisabled: boolean = year >= currentYear;

  return (
    <div className="year-picker-component">
      <div className="icon-container" onClick={handlePreviousYear}>
        <BsChevronLeft className="icon" />
      </div>

      <div className="year-text">{year}</div>

      <div
        className={`icon-container ${isNextYearDisabled ? "disabled" : ""}`}
        onClick={handleNextYear}
      >
        <BsChevronRight className="icon" />
      </div>
    </div>
  );
};
